import React, { useState, useEffect, useMemo } from 'react';
import { Box, Typography, Container } from '@mui/material';
import { FooterContainer } from './Footer.styles';
import { Link as RouterLink } from 'react-router-dom';

const Footer = () => {
    const [quote, setQuote] = useState('');

    const quotes = useMemo(
        () => [
            'The best way to predict the future is to create it.',
            'Every accomplishment starts with the decision to try.',
            'The journey of a thousand miles begins with a single step.',
            'Success is not final, failure is not fatal: It is the courage to continue that counts.',
            'The only way to do great work is to love what you do.',
            "Believe you can and you're halfway there.",
            'It does not matter how slowly you go as long as you do not stop.',
            'Quality is not an act, it is a habit.',
            'The secret of getting ahead is getting started.',
            'Your attitude determines your direction.',
        ],
        []
    );

    useEffect(() => {
        // Select a random quote when component mounts
        const randomIndex = Math.floor(Math.random() * quotes.length);
        setQuote(quotes[randomIndex]);
    }, [quotes]);

    return (
        <FooterContainer>
            <Container maxWidth="lg">
                <Box
                    sx={{
                        py: 3,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <RouterLink
                        to="/admin/login"
                        style={{
                            textDecoration: 'none',
                            color: 'inherit',
                            cursor: 'default',
                        }}
                    >
                        <Typography
                            variant="body1"
                            color="text.secondary"
                            align="center"
                            sx={{
                                fontStyle: 'italic',
                                maxWidth: '800px',
                                fontSize: '1.2rem',
                                fontWeight: 600,
                            }}
                        >
                            "{quote}"
                        </Typography>
                    </RouterLink>
                </Box>
            </Container>
        </FooterContainer>
    );
};

export default Footer;
